var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'player-' + _vm.youtube_id,attrs:{"data-plyr-provider":"youtube","data-plyr-embed-id":_vm.youtube_id}})}
var staticRenderFns = []

export { render, staticRenderFns }